// dailyMutator.ts — picks "today's twist" for Today's Gauntlet. Date is IO, so the pick lives in
// the renderer: Core's DAILY_MUTATORS stays date-free and a ?daily=1 replay of a given day stays
// reproducible (same UTC day key → same mutator for every player → the shared daily leaderboard
// compares like-for-like). FNV-1a over a salted day key, mirroring missionsForDay's approach but
// salted so the twist rotation never correlates with the mission rotation.
import { DAILY_MUTATORS, type DailyMutator } from '../core';
import { utcDayKey } from './stats';

export function mutatorForDay(dayKey: string = utcDayKey()): DailyMutator {
  const salted = `twist:${dayKey}`;
  let h = 0x811c9dc5;
  for (let i = 0; i < salted.length; i += 1) {
    h ^= salted.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return DAILY_MUTATORS[h % DAILY_MUTATORS.length]!;
}

export type { DailyMutator };
